import { Typography } from '@twistopayments/design-system/components/atoms/typography'

import type { ArticleHeadlineComponent } from '@twisto/api-cms'

import { createIdFromSlugAndId } from 'homepage/utils'

import * as styles from './headline.styles'

export const Headline = ({
  tag,
  name,
  id,
  color,
}: ArticleHeadlineComponent) => (
  <Typography
    color={color}
    component={tag}
    css={styles.headline}
    fontWeight="medium"
    id={createIdFromSlugAndId(name, id)}
    variant={tag === 'h4' ? 'b3' : tag}
  >
    {name}
  </Typography>
)
